// 权限派生：菜单看 /me 的并集，按钮看机器人上的有效权限。服务端仍是最终判定。

import type { Me, RobotView } from "./types";

export const P = {
  robotsRead: "robots.read",
  robotsManage: "robots.manage",
  lease: "control.lease",
  drive: "control.drive",
  actionsBasic: "control.actions.basic",
  actionsAll: "control.actions.all",
  estop: "control.estop",
  takeover: "control.takeover",
  mediaView: "media.view",
  mediaTalk: "media.talk",
  usersManage: "users.manage",
  auditRead: "audit.read",
  orgSettings: "org.settings",
  platformOrgs: "platform.orgs",
  aiConfig: "ai_agent.config",
  aiRun: "ai_agent.run",
  aiApprove: "ai_agent.approve",
  aiCatalog: "ai_agent.catalog",
} as const;

export type Perm = (typeof P)[keyof typeof P] | (string & {});

/** 菜单级：任一绑定持有即显示（具体到机器人时再看 `robotHas`）。 */
export function meHas(me: Me | undefined, perm: Perm): boolean {
  if (!me) return false;
  return me.is_platform_admin || me.permissions.includes(perm);
}

/** 机构级：只看机构范围的绑定（分组范围的 robots.manage 管不了机构的分组）。 */
export function meHasOrg(me: Me | undefined, perm: Perm): boolean {
  if (!me) return false;
  return me.is_platform_admin || me.org_permissions.includes(perm);
}

export function meHasAny(me: Me | undefined, perms: readonly Perm[], scope: "any" | "org" = "any"): boolean {
  const f = scope === "org" ? meHasOrg : meHas;
  return perms.length === 0 || perms.some((p) => f(me, p));
}

export function robotHas(robot: Pick<RobotView, "permissions"> | undefined, perm: Perm): boolean {
  return !!robot && robot.permissions.includes(perm);
}

/** 遥控台入口（模块 10 §2：需要 control.lease）。只有急停权限的观看者在详情页用急停按钮。 */
export function canOpenDrive(robot: Pick<RobotView, "permissions"> | undefined): boolean {
  return robotHas(robot, P.lease);
}
